export default {
  createSuccess: "{{ 1 }} created successfully",
  updateSuccess: "{{ 1 }} updated successfully",
  deleteSuccess: "{{ 1 }} deleted successfully",

  updateScheuleSuccess: "Schedule created successfully"
}